import { createLogic } from 'redux-logic';
import { AuthMethod } from 'config/constants';
import * as gatekeeperApi from 'lib/gatekeeperApi';
import { loginSuccess } from 'lib/gaTracking/crossPageEvents';
import * as sbaActions from '../sba/actions';

const sbaAuthentication = createLogic({
  type: sbaActions.createSBAAuthentication,
  async process({ action }, dispatch, done) {
    try {
      dispatch(sbaActions.updateSBAIsAuthenticatingState({ isAuthenticating: true }));

      const { bookingReference, bookingId, email, lastName } = action.payload;
      const token = await gatekeeperApi.createToken({
        bookingReference,
        bookingId,
        email,
        lastName,
      });

      dispatch(sbaActions.createSBAAuthenticationSuccess({ token }));
      loginSuccess(AuthMethod.SBA);
    } catch (error) {
      dispatch(sbaActions.createSBAAuthenticationFailure({ error }));
    } finally {
      dispatch(sbaActions.updateSBAIsAuthenticatingState({ isAuthenticating: false }));
      done();
    }
  },
});

export default sbaAuthentication;
